module.exports = __webpack_public_path__ + "img/code-app.e59693a.png";